import{a as e}from"./chunk-VJTQBXK2.mjs";import{b as m}from"./chunk-LSZKOVGW.mjs";import{j as r,k as o}from"./chunk-GTEBSQTL.mjs";var i=new r({locale:[e,m,o]});export{i as a};
